import { atom } from 'jotai';

export const openMobileNavAtom = atom(false);
